import { useGetCreativesQuery, useGetTagsQuery } from '../../../api/ua-insights'
import { GENRE_TOP_TAGS_LIMIT, LISTING_PAGE_LIMIT } from '../helpers/listing'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * The genre drill-down: the genre's top tags and its creatives, as two calls
 * against the filtered `/tags` and `/creatives` listings.
 */
export const useGenreTagsListing = (genreId: string | null | undefined) => {
  const { networkId, month } = useUAInsightsScope()
  const scope = { genreId: genreId ?? undefined, networkId: networkId ?? undefined, month: month ?? undefined }
  const tags = useGetTagsQuery({ ...scope, limit: GENRE_TOP_TAGS_LIMIT }, { skip: !genreId })
  const creatives = useGetCreativesQuery({ ...scope, limit: LISTING_PAGE_LIMIT }, { skip: !genreId })

  const data =
    tags.data && creatives.data
      ? { prevalentTags: tags.data.tags, creativeAds: creatives.data.creatives, creativesTotal: creatives.data.page.total }
      : undefined
  const refetch = () => {
    tags.refetch()
    creatives.refetch()
  }
  return { data, isLoading: tags.isFetching || creatives.isFetching, isError: tags.isError || creatives.isError, refetch }
}
